import { Layout, CurrentFanbandStats, AlertsSent } from 'components/widgets';
import { Promo } from 'components/containers';
import { usePathIndicator } from 'hooks';
import { ALERT_PROTO_TYPES, LINKS } from 'utils/constants';

export default function PromoPage() {
  usePathIndicator(LINKS.promo);

  return (
    <Layout
      sidebar={
        <>
          <CurrentFanbandStats />
          <AlertsSent
            type={ALERT_PROTO_TYPES.promo}
            link={LINKS.promoSent.path}
          />
        </>
      }
    >
      <Promo />
    </Layout>
  );
}
